import React, { useEffect } from "react";
import left from "../../../images/Banner/left.png";
import right from "../../../images/Banner/right.png";
import Aos from "aos";

const BannerItems = ({
  items,
  index,
  sliderRef,
  moblieScreen,
  activeAnimation,
}) => {
  useEffect(() => {
    Aos.init();
  }, []);
  return (
    <div className="slider_img" key={index}>
      <div className="d-flex align-items-center justify-content-around">
        <div
          className="left_arrows"
          onClick={() => sliderRef.current.slickPrev()}
        >
          <img src={right} alt="" />
        </div>
        <div
          className="right_arrows"
          onClick={() => sliderRef.current.slickNext()}
        >
          <img src={left} alt="" />
        </div>
      </div>
      {!moblieScreen ? (
        <div className="container w-100">
          {activeAnimation && (
            <div className="silder_text">
              <h1 data-aos-duration="500" data-aos="fade-right">
                {items?.DesktopTitle}
              </h1>
              {items.DesktopSubTitle2 && (
                <p data-aos-duration="1000" data-aos="fade-right">
                  {items.DesktopSubTitle2}
                </p>
              )}
              {items.DesktopSubTitle22 && (
                <p data-aos-duration="1000" data-aos="fade-right">
                  {items.DesktopSubTitle22}
                </p>
              )}

              {!items.Desktopdta && (
                <>
                  <p
                    className="py-0"
                    data-aos-duration="1000"
                    data-aos="fade-right"
                  >
                    <span>{items?.DesktopColorText}</span>
                    {items?.DesktopSubTitle} <br />
                    {items.dataHome && <p>{items.DesktopSubTitle3}</p>}
                  </p>
                </>
              )}

              <button
                className="slider_btn"
                data-aos-duration="1400"
                data-aos="fade-right"
              >
                Browse Category
              </button>
              {items.Desktopdta && (
                <p
                  className="pt-2"
                  data-aos-duration="1000"
                  data-aos="fade-right"
                >
                  <span>{items?.DesktopColorText}</span>{" "}
                  {items?.DesktopSubTitle} <br />
                  {items?.DesktopSubTitle3}
                </p>
              )}
            </div>
          )}
        </div>
      ) : (
        <div className="container w-100">
          {activeAnimation && (
            <div className="silder_text">
              <h1 data-aos-duration="500" data-aos="fade-right">
                {items?.MobileTitle}
              </h1>
              {items.MobileSubTitle2 && (
                <p data-aos-duration="1000" data-aos="fade-right">
                  {items.MobileSubTitle2}
                </p>
              )}
              {items.MobileEleSubTitle2 && (
                <p data-aos-duration="1000" data-aos="fade-right">
                  {items.MobileEleSubTitle2}
                </p>
              )}
              {items.MobileSubTitle22 && (
                <p data-aos-duration="1000" data-aos="fade-right">
                  {items.MobileSubTitle22}
                </p>
              )}
              {items.MobileSubTitle23 && (
                <p data-aos-duration="1000" data-aos="fade-right">
                  {items.MobileSubTitle23}
                </p>
              )}

              {!items.Mobilepdta && (
                <>
                  <p
                    className="py-0"
                    data-aos="fade-right"
                    data-aos-duration="1000"
                  >
                    <span>{items?.MobileColorText}</span>{" "}
                    {items?.MobileSubTitle}
                    <br />
                    {items.MobileSubTitle3}
                  </p>
                </>
              )}
              <button
                className="slider_btn"
                data-aos-duration="1400"
                data-aos="fade-right"
              >
                Browse Category
              </button>
              {items.Mobilepdta && (
                <p
                  className="pt-2"
                  data-aos-duration="1000"
                  data-aos="fade-right"
                >
                  <span>{items?.MobileColorText}</span> {items?.MobileSubTitle}{" "}
                  <br />
                  {items?.MobileSubTitle3}
                </p>
              )}
            </div>
          )}
        </div>
      )}

      <img src={items?.imgDesktop} className="slider_img_desktop" alt="" />
      <img src={items?.imgMobile} className="slider_img_mobile" alt="" />
    </div>
  );
};

export default BannerItems;
